
<template>
  <!--新增设备-->
  <x-addEdit
    :apiOrigin="apiOrigin"
    :formList="formList"
    :formKey="formKey"
    :addParam="addParam"
    :editParam="editParam"
    :detailParam="detailParam"
  >
  </x-addEdit>
</template>

<script>
import { fetchSelect } from '../../../utils/mixins';
export default {
  mixins: [fetchSelect],
  name: 'addEquipment',
  data () {
    return {
      apiOrigin: 'PHP',
      formList: [
        {
          label: '所属小区',
          inputType: 'select',
          options: [],
          placeholder: '选择小区',
          fetchOptions: this.getOptions,
          props: ['community_id', {
            rules: [{ required: true, message: '请选择所属小区' }]
          }]
        },
        {
          label: '名称',
          inputType: 'input',
          options: [],
          placeholder: '名称',
          props: ['title', {
            rules: [
              { required: true, message: '请输入名称' },
              { min: 1, max: 20, message: '不超过20个字' }
            ]
          }]
        },
        {
          label: 'IP/域名',
          inputType: 'input',
          options: [],
          placeholder: 'IP/域名',
          props: ['url', {
            rules: [{ required: true, message: '请输入IP/域名' }]
          }]
        },
        {
          label: ' 端口',
          inputType: 'input',
          options: [],
          placeholder: ' 端口号',
          props: ['port', {
            rules: [{ required: true, message: '请输入端口号' }]
          }]
        },
        {
          label: ' 序列号',
          inputType: 'input',
          options: [],
          placeholder: ' 序列号',
          props: ['device_sncode', {
            rules: [{ required: true, message: '请输入序列号' }]
          }]
        },
        {
          label: '用户名',
          inputType: 'input',
          options: [],
          placeholder: '用户名',
          props: ['user_name', {
            rules: [
              { required: true, message: '请输入用户名' },
              { pattern: this.REG.name, message: this.MESSAGE.name }
            ]
          }]
        },
        {
          label: '密码',
          inputType: 'input',
          options: [],
          placeholder: '密码',
          props: ['password', {
            rules: [
              { required: true, message: '请输入密码' }
              // { pattern: this.REG.passWord, message: this.MESSAGE.passWord }
            ]
          }]
        }
      ],
      formKey: {
        community_id: '',
        title: '',
        url: '',
        port: '',
        device_sncode: '',
        user_name: '',
        password: ''
      },
      addParam: {
        url: '/aisecurity/watchdogs',
        reqHandle: this.reqHandle, // this.reqHandle
        resHandle: '' // this.addResHandle
      },
      editParam: {
        url: '/aisecurity/watchdogs/',
        resHandle: '' // this.editResHandle
      },
      detailParam: {
        url: '/aisecurity/watchdogs/',
        resHandle: this.detailResHandle
      }
    };
  },
  created () {
    if (this.$route.query.id) {
      this.formList[0].disabled = true;
      this.formList[4].disabled = true;
    }
    // this.communitySelect(0, 'formList', 1);

    this.communitySelectByStep(1, undefined, undefined, '0');
  },
  methods: {
    getOptions (pageNum, search) {
      return this.communitySelectByStep(pageNum, search, undefined, '0');
    },
    reqHandle (param) {
      return param;
    },
    addResHandle (res) {
      return res;
    },
    editResHandle (res) {
      return res;
    },
    detailResHandle (res) {
      res.community_id = Number(res.community_id);
      return res;
    }
  }
};
</script>
